import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import NativeSelect from '@mui/material/NativeSelect';
import { validateRequiredSelect } from '../validate';

const STATUSES = [
    { id: '', title: 'news.selectStatus' },
    { id: true, title: 'table.yes' },
    { id: false, title: 'table.no' },
];

const renderStatusField = ({ input, meta: { touched, error }, i18n, ...custom }) => {
    const showError = touched && error;
    return (
        <div
            style={{
                borderBottom: showError ? '2px solid red' : '2px solid transparent',
                paddingBottom: 4,
            }}
        >
            <NativeSelect {...input} {...custom}>
                {STATUSES.map((item, key) => (
                    <option key={key} value={item.id}>
                        {i18n.t(item.title)}
                    </option>
                ))}
            </NativeSelect>
        </div>
    );
};

export default ({ label, code }) => {
    const { i18n } = useTranslation();

    return (
        <Card>
            <CardContent>
                <Typography gutterBottom variant="h6" component="h2">
                    {i18n.t(label)}
                </Typography>
                <Field
                    name={code}
                    i18n={i18n}
                    component={renderStatusField}
                    type="boolean"
                    validate={validateRequiredSelect}
                />
            </CardContent>
        </Card>
    );
};
